import * as React from "react";
const SvgFiRrHatSanta = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-santa_svg__a)">
      <path
        fill="#062147"
        d="M21.942 17.311c-.289-2.708-1.18-5.231-2.173-7.318q.115.006.232.007c2.206 0 4-1.794 4-4a4.004 4.004 0 0 0-4.623-3.951l-.153-.103C17.804.989 16.334 0 14.001 0 10.649 0 3.913 3.635 2.081 17.303A3.5 3.5 0 0 0 0 20.502c0 1.93 1.57 3.5 3.501 3.5L20.5 24c1.93 0 3.5-1.571 3.5-3.5a3.51 3.51 0 0 0-2.058-3.189M22 6c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m-8-4c1.357 0 2.297.439 3.286 1.064-.41.379-.74.842-.964 1.362l-.054-.066a1.001 1.001 0 0 0-1.537 1.28c.045.055 4.296 5.217 5.158 11.36l-15.745.002C5.951 4.732 11.825 2 14 2m6.5 20-16.999.002A1.503 1.503 0 0 1 2 20.502c0-.827.673-1.5 1.5-1.5l17-.002c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-santa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatSanta;
